module.exports = __webpack_public_path__ + "img/UpGPT.c4a1275d.svg";